import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Listing, User } from '@curbnturf/entities';
import {
  DisplayValidationErrorsDirective,
  DisplayValidationErrorsSubmitButtonDirective,
  DisplayValidationErrorsSubmitDirective,
} from '@curbnturf/form-helpers';
import { MessageFacade } from '@curbnturf/message/src/lib/+state/message.facade';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'curbnturf-ask-host-modal',
  templateUrl: './ask-host-modal.component.html',
  styleUrls: ['./ask-host-modal.component.scss'],
  standalone: true,
  imports: [
    DisplayValidationErrorsDirective,
    DisplayValidationErrorsSubmitDirective,
    DisplayValidationErrorsSubmitButtonDirective,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
  ],
})
export class AskHostModalComponent {
  @Input() listing: Listing;
  @Input() user: User;

  form: FormGroup<{ message: FormControl<string | null> }>;

  constructor(
    private fb: FormBuilder,
    private messageFacade: MessageFacade,
    private modalController: ModalController,
  ) {
    this.form = this.fb.group({
      message: ['', [Validators.required]],
    });
  }

  closeModal() {
    this.modalController.dismiss();
  }

  confirm(): void {
    if (this.form.valid && this.form.value.message) {
      const message = {
        body: this.form.value.message,
        channel: {
          listing: { id: this.listing.id },
          user: { id: this.user.id },
        },
      };

      this.messageFacade.create(message);
    }

    this.closeModal();
  }

  decline(): void {
    this.closeModal();
  }
}
